import { useContext } from "react";
import { BillingInformationContext } from "../../Account/BillingInformation/BillingInformationContext";
import { useGiftCardApplyForm } from "../GiftCardApply/useGiftCardApplyForm";
import { useCheckoutCouponModal } from "../Coupon/useCheckoutCouponModal";
import { useFormContext } from "react-hook-form";
export const usePaymentSection = () => {
    const { control, setValue, getFieldState, formState, watch, clearErrors } = useFormContext();
    const { error: paymentMethodError } = getFieldState("paymentMethod", formState);
    const { customerCreditCards, addedNewCard, setAddedNewCard, publicKey, stripePublishableKey, clientSecret, setClientSecret, paymentIntentId, primaryCreditCard, dismissedAddPaymentModal, setDismissedAddPaymentModal, token, paymentProcessor } = useContext(BillingInformationContext);
    const { showCouponForm } = useCheckoutCouponModal();
    const giftCardModalProps = useGiftCardApplyForm();
    return {
        customerCreditCards,
        addedNewCard,
        clientSecret,
        setClientSecret,
        stripePublishableKey,
        publicKey,
        paymentIntentId,
        control,
        watch,
        clearErrors,
        setValue,
        paymentMethodError,
        primaryCreditCard,
        setAddedNewCard,
        showCouponForm,
        giftCardModalProps,
        dismissedAddPaymentModal,
        setDismissedAddPaymentModal,
        token,
        paymentProcessor
    };
};
